export const yearSelection = [
  { id: '1970' },
  { id: '1971' },
  { id: '1972' },
  { id: '1973' },
  { id: '1974' },
  { id: '1975' },
  { id: '1976' },
  { id: '1977' },
  { id: '1978' },
  { id: '1979' },
  { id: '1980' },
  { id: '1981' },
  { id: '1982' },
  { id: '1983' },
  { id: '1984' },
  { id: '1985' },
  { id: '1986' },
  { id: '1987' },
  { id: '1988' },
  { id: '1989' },
  { id: '1990' },
  { id: '1991' },
  { id: '1992' },
  { id: '1993' },
  { id: '1994' },
  { id: '1995' },
  { id: '1996' },
  { id: '1997' },
  { id: '1998' },
  { id: '1999' },
  { id: '2000' },
  { id: '2001' },
  { id: '2002' },
  { id: '2003' },
  { id: '2004' },
  { id: '2005' },
  { id: '2006' },
  { id: '2007' },
  { id: '2008' },
  { id: '2009' },
  { id: '2010' },
  { id: '2011' },
  { id: '2012' },
  { id: '2013' },
  { id: '2014' },
  { id: '2015' },
  { id: '2016' },
  { id: '2017' },
  { id: '2018' },
  { id: '2019' },
  { id: '2020' },
  { id: '2021' },
  { id: '2022' },
  { id: '2023' },
];

export const bloodGroupSelection = [
  { id: 1, name: 'A+' },
  { id: 2, name: 'A-' },
  { id: 3, name: 'B+' },
  { id: 4, name: 'B-' },
  { id: 5, name: 'AB+' },
  { id: 6, name: 'AB-' },
  { id: 7, name: 'O+' },
  { id: 8, name: 'O-' },
];

export enum BloodGroup {
  APositive = 1,
  ANegative = 2,
  BPositive = 3,
  BNegative = 4,
  ABPositive = 5,
  ABNegative = 6,
  OPositive = 7,
  ONegative = 8,
}
export const RelationType = [
  { id: 1, name: 'Wife' },
  { id: 2, name: 'Husband' },
  { id: 3, name: 'Mother' },
  { id: 4, name: 'Father' },
  { id: 5, name: 'Son' },
  { id: 6, name: 'Daughter' },
  { id: 7, name: 'Brother' },
  { id: 8, name: 'Sister' },
  { id: 9, name: 'Grandfather' },
  { id: 10, name: 'Grandmother' },
  { id: 11, name: 'Other' },
  { id: 12, name: 'Father-in-law' },
  { id: 13, name: 'Mother-in-law' },
];

export const SelectRecordType = [
  { id: 1, name: 'Prescription' },
  { id: 2, name: 'LabReport' },
  { id: 3, name: 'DischargeSummary' },
  { id: 4, name: 'Imaging' },
  { id: 5, name: 'Others' },
  // { id: 6, name: 'Vital' },
];

export enum UserType {
  Doctor = 1,
  Patient = 2,
  Admin = 3,
  Receptionist = 4,
  Watcher = 6,
  HospitalManager = 7,
  OperationManager = 8,
  PharmacyApprover = 10,
  Pharmacist = 11,
  PharmacyManager = 12,
  WhatsappManager = 9,
  Auditor = 13,
  TaskReviewer = 14,
  StoreManager = 15,
  StoreApproval = 17,
  StockTransfer = 18,
  BackdateBillCreator = 19,
  MaximumDiscountOverride = 20,
}

export enum StaffRoles {
  Receptionist = 4,
  ClinicManager = 7,
  OperationManager = 8,
}
export const taggingValues = [
  { name: 'Yes', value: true },
  { name: 'No', value: false },
];
export enum Relationship {
  Wife = 1,
  Husband = 2,
  Mother = 3,
  Father = 4,
  Son = 5,
  Daughter = 6,
  Brother = 7,
  Sister = 8,
  GrandFather = 9,
  GrandMother = 10,
  Other = 11,
  FatherInLaw = 12,
  MotherInLaw = 13,
}

export enum UserMedicalProfileType {
  SymptomLog = 1,
  FoodAllergy = 2,
  MedicineAllergy = 3,
  OtherAllergy = 4,
  CurrentDisease = 5,
  PastProcedure = 6,
  HealthEpisode = 7,
  Medication = 8,
  CovidVaccination = 9,
  LifestyleChoice = 10,
  FamilyHistory = 11,
  Record = 100,
}

export enum MedicalProfileEnum {
  Symptom = 1,
  FoodAllergy = 2,
  OtherAllergy = 3,
  Disease = 4,
  Procedure = 5,
  Medicine = 6,
  HereditaryDisease = 7,
  MedicationType = 8,
  MedicationFrequency = 9,
  MedicationFoodTiming = 10,
}

export enum LifeStyleChoicesEnum {
  Alcohol = 1,
  Exercise = 2,
  Sleep = 3,
  Smoke = 4,
  Tobacco = 5,
  WaterConsumption = 6,
}
export const MedicationSideMenuList = [
  {
    id: '1',
    name: 'Current Medication',
  },
  {
    id: '2',
    name: 'Past Medication',
  },
];

export const LinkingSideMenuList = [
  {
    id: '1',
    name: 'Medications',
  },
  {
    id: '2',
    name: 'Past Procedure',
  },
  {
    id: '3',
    name: 'Records',
  },
];

export enum Severity {
  Low = 1,
  Medium = 2,
  High = 3,
}

export enum Months {
  Jan = 1,
  Feb = 2,
  Mar = 3,
  Apr = 4,
  May = 5,
  Jun = 6,
  Jul = 7,
  Aug = 8,
  Sep = 9,
  Oct = 10,
  Nov = 11,
  Dec = 12,
}

export enum RecordType {
  Prescription = 1,
  LabReport = 2,
  DischargeSummary = 3,
  Imaging = 4,
  Other = 5,
  Vital = 6,
  EPrescription = 7,
}

export enum PaymentModeEnum {
  BankTransfer = 1,
  UPI = 2,
  Cash = 3,
  ViaLink = 4,
  PaymentGateWay = 5,
  NA = 6,
  Invoice = 7,
  Wallet = 8,
}

export enum ActivityHistory {
  Booked = 1,
  Arrived = 2,
  Attended = 3,
  Cancelled = 4,
  NoShow = 5,
  Rescheduled = 6,
  Rebooked = 7,
  Reviewed = 8,
  PrescriptionUploaded = 9,
  Paid = 10,
  Source = 11,
  Location = 12,
  Note = 13,
  Coupon = 14,
  BeingAttended = 18,
}

export enum PaymentStatus {
  Paid = 1,
  Unpaid = 2,
  Refunded = 3,
  RefundInitiated = 4,
  FreeReview = 5,
}

export enum ActorType {
  Doctor = 1,
  PrimaryUser = 2,
  Self = 3,
  Admin = 4,
  System = 5,
  Receptionist = 6,
  ClinicManager = 7,
  OperationManager = 8,
}

export enum CsvType {
  Prescription = 1,
  Appointment = 2,
}
